module.exports = __webpack_public_path__ + "img/next.53d3152f.svg";